import { setReduceMotionSetting } from '../helpers/motion.js';
import { graphChromeStyles } from '../ns-graph/graph-chrome-styles.js';
import { nsButtonStyles } from './ns-button-styles.js';
import { nsLayoutStyles } from './ns-layout-styles.js';
import { reducedMotionRule } from './ns-motion-styles.js';
import { nsSharedStyles } from './ns-shared-styles.js';

const documentSheet = new CSSStyleSheet();
const insertedRules = new Map<CSSStyleSheet, CSSRule>();

// Every component adopting these styles shares one sheet per module, so one inserted rule reaches them all
function motionCarrierSheets() {
  return [
    documentSheet,
    ...[nsSharedStyles, nsLayoutStyles, nsButtonStyles, graphChromeStyles].flatMap((styles) => styles.styleSheet ?? []),
  ];
}

export function applyReduceMotionSetting(on: boolean) {
  setReduceMotionSetting(on);
  if (!document.adoptedStyleSheets.includes(documentSheet)) {
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, documentSheet];
  }

  motionCarrierSheets().forEach((sheet) => {
    const inserted = insertedRules.get(sheet);
    if (on && !inserted) {
      const index = sheet.insertRule(reducedMotionRule.cssText, sheet.cssRules.length);
      insertedRules.set(sheet, sheet.cssRules[index]);
    } else if (!on && inserted) {
      sheet.deleteRule([...sheet.cssRules].indexOf(inserted));
      insertedRules.delete(sheet);
    }
  });
}
